const projects = [
  {
    name: 'Catch Up',
    slug: 'catch-up',
    mainImage: '/images/projects/catch-up/banner-catch-up.webp',
    thumbnail: '/images/projects/catch-up/thumbnail-catch-up.webp',
    description: {
      issue: [
        'Разработать VR-аналог на классическую аркаду в рамках практики. Необходимо было создать оптимизированную под мобильную VR гарнитуру игру с простым, но увлекательным геймплеем, сохранив очарование оригинальной механики.',
      ],
      process: [
        'Разработка началась с создания атмосферы — амбар с курочками, деревянные желоба и другие элементы окружения. Особое внимание уделили оптимизации, чтобы графика выглядела хорошо, но при этом обеспечивала высокий FPS в VR-очках.',
        'Сложнее всего оказалось настроить физику движения яиц. Нужно было, чтобы они реалистично скатывались по желобам, не застревали в текстурах и не вели себя слишком «упруго» при столкновениях. После нескольких итераций удалось добиться плавного и предсказуемого движения.',
        'Для сохранения азарта добавили систему рекордов с облачным хранением результатов — теперь игроки могут соревноваться друг с другом.',
      ],
      result: [
        'После доработки Catch Up вышла в магазине SideQuest. Игра сочетает простую механику с приятной графикой и хорошей оптимизацией. Игроки отмечают ностальгическую атмосферу и удобное управление, а система рекордов добавляет соревновательный элемент.',
        'Приложение доступно в магазине по следующей <a href="https://sidequestvr.com/app/11402/catch-up">ссылке</a>.',
      ],
    },
    shortDescription:
      'А вы играли в легендарную игру «Ну, погоди!» с волком и яйцами? Технологии не стоят на месте и в эпоху VR мы создали её реинкарнацию — и теперь, надев очки, игрок оказывается в уютном деревенском амбаре, где нужно ловить скатывающиеся по желобам яйца.',
    images: [
      '/images/projects/catch-up/img-catch-up-1-1024x576.webp',
      '/images/projects/catch-up/img-catch-up-1024x576.webp',
      '/images/projects/catch-up/img-catch-up-2-1024x576.webp',
      '/images/projects/catch-up/img-catch-up-4-1024x576.webp',
      '/images/projects/catch-up/img-catch-up-7-1024x576.webp',
    ],
    videos: [
      {
        id: Math.random().toString(36).substring(2),
        poster: '/images/projects/catch-up/thumbnail-catch-up.webp',
        sources: [
          {
            src: '/videos/projects/catch-up/catch-up-video.mp4',
            type: 'video/mp4',
          },
        ],
      },
    ],
  },
  {
    name: 'PitStop',
    slug: 'pitstop',
    mainImage: '/images/projects/pitstop/banner-pitstop.webp',
    thumbnail: '/images/projects/pitstop/thumbnail-pitstop.webp',
    description: {
      issue: [
        'В рамках практики стояла задача разработать реалистичный VR-симулятор автомеханика для мобильной VR-гарнитуры. Основная цель — создать интерактивную среду с детализированным автомобилем и инструментами, где игрок может выполнять ремонтные работы по инструкции.',
      ],
      process: [
        'Мы начали с проектирования сцены мастерской и реализации ключевых механик: подъём автомобиля на гидравлическом подъёмнике, снятие и установка колёс, а также замена тормозных колодок и дисков. Для удобства игроков добавили удобную систему подсветки активных деталей при выполнении заданий.',
        'Основные сложности заключались в оптимизации графики для стабильной работы на VR-шлемах. Пришлось тщательно настраивать физику взаимодействия с мелкими деталями вроде гаек и болтов.',
        'Одной из интересных задач стало создание понятного интерфейса с пошаговыми инструкциями.',
        'После успешного прототипа проект доработали: улучшили графику, добавили новые виды ремонта и расширили функционал мастерской.',
      ],
      result: [
        'Готовый симулятор PitStop опубликован в магазине SideQuest. Игра предлагает реалистичные механики ремонта автомобиля с пошаговой системой обучения. Разработчикам удалось реализовать симулятор с высоким уровнем комфорта благодаря тщательной оптимизации графики и физики объектов. Игроки могут выполнять различные виды работ.',
        'Проект получил положительные отзывы за детализацию и реалистичность рабочих процессов.',
        'Приложение доступно в магазине по следующей <a href="https://sidequestvr.com/app/35189/pit-stop">ссылке</a>.',
      ],
    },
    shortDescription:
      'Хотите почувствовать себя настоящим автомехаником? В VR-симуляторе PitStop вы сможете поднять машину на подъёмнике, поменять колёса и тормозные диски, отремонтировать автомобиль — всё как в реальной мастерской.',
    images: [
      '/images/projects/pitstop/img-pitstop-3-1024x576.webp',
      '/images/projects/pitstop/img-pitstop-4-1024x576.webp',
      '/images/projects/pitstop/img-pitstop-5-1024x576.webp',
      '/images/projects/pitstop/img-pitstop-6-1024x576.webp',
      '/images/projects/pitstop/img-pitstop-7-1024x576.webp',
    ],
    videos: [
      {
        id: Math.random().toString(36).substring(2),
        poster: '/images/projects/pitstop/thumbnail-pitstop.webp',
        sources: [
          {
            src: '/videos/projects/pitstop/pitstop-video.mp4',
            type: 'video/mp4',
          },
        ],
      },
    ],
  },
  {
    name: 'Snow Defense',
    slug: 'snow-defense',
    mainImage: '/images/projects/snow-defense/banner-snow-defense.webp',
    thumbnail: '/images/projects/snow-defense/thumbnail-snow-defense.webp',
    description: {
      issue: [
        'Создать VR-игру, где игрок ощутит себя настоящим стражем ледяной цитадели.',
        'Нам предстояло не просто сделать очередной tower defense, а погрузить игрока в эпичную зимнюю сагу, где снег становится оружием, а каждый противник — испытанием.',
      ],
      process: [
        'На старте мы использовали gray-box прототипирование - базовые модели окружения, оружия и врагов помогли быстро проверить игровую механику. После этого приступили к следующей фазе и добавили три типа оружия: снеговую пушку, катапульту и пулемёт, каждый со своими характеристиками.',
        'Основные сложности возникли с физикой взаимодействий в VR: нужно было сделать так, чтобы игрок мог комфортно управлять оружием и чувствовать отдачу. Другая проблема - оптимизация, так как большое количество объектов и визуальных эффектов создавало нагрузку на систему.',
        'После успешного тестирования прототипа мы значительно расширили игру: добавили 40 уровней, систему улучшения оружия, новых врагов и двух боссов. Особое внимание уделили магазину, где игрок может выбирать и покупать оружие в VR-пространстве.',
      ],
      result: [
        'Snow Defense вырвалась за пределы учебного проекта. Сорок уровней с коварными врагами, два легендарных босса и арсенал. Игра стала тем, во что верили с самого начала: зимней сагой о выживании.',
        'Она собрала сотни игроков и продолжает наполняться новыми интересными идеями.',
        'Приложение доступно в магазине по следующей <a href="https://sidequestvr.com/app/41246/snow-defense">ссылке</a>.',
      ],
    },
    shortDescription:
      'Зимний замок, бесконечные волны огненных элементалей и арсенал снегометательного оружия — расскажем о том, как мы создали VR-игру, в которой вы защищаете крепость в эпичной битве! ',
    images: [
      '/images/projects/snow-defense/img-snow-defense-2-1024x576.webp',
      '/images/projects/snow-defense/img-snow-defense-3-1024x576.webp',
      '/images/projects/snow-defense/img-snow-defense-5-1024x576.webp',
      '/images/projects/snow-defense/img-snow-defense-6-1024x576.webp',
      '/images/projects/snow-defense/img-snow-defense-7-1024x576.webp',
    ],
    videos: [
      {
        id: Math.random().toString(36).substring(2),
        poster: '/images/projects/snow-defense/thumbnail-snow-defense.webp',
        sources: [
          {
            src: '/videos/projects/snow-defense/snow-defense-video.mp4',
            type: 'video/mp4',
          },
        ],
      },
    ],
  },
  {
    name: 'Trivver',
    slug: 'trivver',
    mainImage: '/images/projects/trivver/Trivver_1920px.jpg',
    thumbnail: '/images/projects/trivver/iPad.jpg',
    description: {
      issue: [
        'Любите компьютерные игры? Как насчет таргетированной рекламы внутри игр? Скажем, вы фанат кока-колы и не любите пепси - так почему бы не показывать вам ее в виртуальном мире? Наш клиент взял эту идею за основу успешного стартапа и привлек нашу команду для ее реализации.',
      ],
      process: [
        'Наши лучшие технические архитекторы собрались вместе для решения вопросов, связанных с масштабируемостью и использованием решения. После того как план был готов, команда Unity, PHP и мобильных разработчиков взялась за дело!',
      ],
      result: [
        'Первый релиз был суперуспешным и привлек несколько раундов инвестиций плюс много идей по развитию. AR/VR/Блокчейн - все это есть у нас!',
      ],
    },
    shortDescription:
      'Любите компьютерные игры? Как насчет таргетированной рекламы внутри игр? Скажем, вы фанат кока-колы и не любите пепси - так почему бы не показывать вам ее в виртуальном мире? Наш клиент взял эту идею за основу успешного стартапа и привлек нашу команду для ее реализации.',
    images: [
      '/images/projects/trivver/bg_1@1x.jpg',
      '/images/projects/trivver/bg_2@1x.jpg',
      '/images/projects/trivver/bg_3@1x.jpg',
    ],
  },
  {
    name: 'VR Puzzle Box',
    slug: 'vr-puzzle-box',
    mainImage: '/images/projects/vr-puzzle-box/VRPuzzleBox-head-new.png',
    thumbnail: '/images/projects/vr-puzzle-box/VRPuzzleBox-projects.jpg',
    description: {
      issue: [
        'В 2019 году наша компания принимала участие в конференции DUMP, специально для которой было разработано приложение - VR Puzzle Box. По результатам презентации созданный прототип игры получил положительные отзывы от участников. Прислушавшись к фидбэку пользователей, мы расширили  функционал игры и разместили ее в <a target="_blank" rel="noopener noreferrer" href="https://store.steampowered.com/app/1125730/VR_Puzzle_Box/">steam</a>.',
      ],
      process: [
        'Одной из сложных задач оказалась физика взаимодействия с объектами виртуальной реальности или, другими словами, как научить пользователя взаимодействовать с несуществующими объектами. Как взять предмет, как его повернуть, как его положить, не нарушая законы физики? Для этого была реализована физическая модель с пружинами, которые разрываются, если ты нарушаешь эти законы.',
        ' Еще одним интересным моментом стала разработка механизм подъема и опускания игровой поверхности, так как мы разрабатывали игру, в которой пользователь должен был играть стоя, и в процессе тестирования поняли, что рост игроков у всех разный.',
      ],
      result: [
        'Результатом стала разработанная игра, в которой пользователь должен расположить объемные детали головоломки на игровом поле таким образом, чтобы получилось плоское двухмерное изображение. Игра имеет несколько уровней сложности и режимов.',
        'Данное приложение можно скачать в <a target="_blank" rel="noopener noreferrer" href="https://store.steampowered.com/app/1125730/VR_Puzzle_Box/">steam</a>.',
      ],
    },
    shortDescription:
      'В 2019 году наша компания принимала участие в конференции DUMP, специально для которой было разработано приложение - VR Puzzle Box. По результатам презентации созданный прототип игры получил положительные отзывы от участников.',
    images: [
      '/images/projects/vr-puzzle-box/1.jpg',
      '/images/projects/vr-puzzle-box/2.jpg',
      '/images/projects/vr-puzzle-box/3.jpg',
      '/images/projects/vr-puzzle-box/4.jpg',
      '/images/projects/vr-puzzle-box/5.jpg',
      '/images/projects/vr-puzzle-box/6.jpg',
    ],
    videos: [
      {
        id: Math.random().toString(36).substring(2),
        poster: '/images/projects/vr-puzzle-box/VRPuzzleBox@video-preview.jpg',
        sources: [
          {
            src: '/videos/projects/vr-puzzle-box/1.mp4',
            type: 'video/mp4',
          },
          {
            src: '/videos/projects/vr-puzzle-box/1.webm',
            type: 'video/webm',
          },
        ],
      },
    ],
  },
  {
    name: 'August McGregor',
    slug: 'august-mcgregor',
    mainImage: '/images/projects/august-mcgregor/2_1920.png',
    description: {
      issue: [
        'Разработать маркетинговый промо-сайт для модельера одежды Коннора МакГрегора, да еще и перед его важным боем с непобедимым Флойдом Мэйуэзером!',
      ],
      process: [
        'Несмотря на то, что на сайте всего одна страница, каждая деталь была точно отполирована и выверена. Добавьте сюда еще недельный дедлайн и получите работу, которую может сделать только наша команда!',
      ],
      result: [
        'Бой прошел успешно. Пусть Коннор и не победил, но его партнерский сайт получил много заявок. Следите за обновлениями!',
      ],
    },
    images: [
      '/images/projects/august-mcgregor/1.jpg',
      '/images/projects/august-mcgregor/2.jpg',
      '/images/projects/august-mcgregor/3.jpg',
    ],
    thumbnail: '/images/projects/august-mcgregor/2_1920.png',
  },
  {
    name: 'Medic Clipboard',
    slug: 'medic-clipboard',
    mainImage: {
      x1: '/images/projects/medic-clipboard/3_1920px.png',
      placeholder: '/images/projects/medic-clipboard/3_1920px@placeholder.jpg',
    },
    description: {
      issue: [
        'Что если детальная медицинская информация с места выезда бригад скорой помощи будет поступать на пульт мгновенно - сколько жизней можно спасти? Наш клиент - инновационная компания, которая поставила перед собой задачу перевода бумажной работы парамедиков в цифровой формат и интеграции этого решения с диспетчерскими центрами. ',
      ],
      process: [
        'Задача, признаться, нелегкая ведь приложение должно быть всегда доступно и понятно для медицинской бригады - на счету каждая секунда. Наши ребята работали над созданием простого интерфейса максимально похожего на существующие государственные формы, которые использовались при бумажной работе. ',
      ],
      result: [
        'Приложение активно работает в округе Лос-Анджелеса - надеемся, что мы спасли не одну жизнь! Ведь теперь больницы получают всю информацию о прибывающем пациенте еще до момента приезда бригады, а значит могут приготовить все необходимое для оказания помощи!',
      ],
    },
    images: [
      '/images/projects/medic-clipboard/1.jpg',
      '/images/projects/medic-clipboard/2.jpg',
      '/images/projects/medic-clipboard/3.jpg',
    ],
    thumbnail: '/images/projects/medic-clipboard/1.jpg',
  },
  {
    name: 'Microchip',
    slug: 'microchip',
    mainImage: '/images/projects/microchip/4_1920px.jpg',
    thumbnail: '/images/projects/microchip/Iot.jpg',
    description: {
      issue: [
        'Один из крупнейших мировых производителей микропроцессоров обратился к нам за помощью в создании интегрированного IoT решения для прототипирования проектов на базе контроллеров Microchip.',
      ],
      process: [
        'Наши инженеры разработали прошивку для прототипа, соединили его с облачными сервисами и создали мобильное решение для получения информации с сенсоров.',
      ],
      result: [
        'Компания Microchip активно продвигает решение через семинары, тренинги, конференции и подключает нас для разработки индивидуальных проектов. ',
      ],
    },
    shortDescription:
      'Мы разработали полное IoT решение на базе партнерства с одним из крупнейших провайдеров мобильной связи (AT&T).',
    images: [
      '/images/projects/microchip/1.jpg',
      '/images/projects/microchip/2.jpg',
      '/images/projects/microchip/3.jpg',
    ],
  },
  {
    name: 'National Signal',
    slug: 'national-signal',
    mainImage: '/images/projects/national-signal/5_1920px.jpg',
    thumbnail: '/images/projects/national-signal/Iot.jpg',
    description: {
      issue: [
        'Компания National Signal решила пойти в сторону облачных решений для диагностики и обновления информации на мобильных информационных экранах, которые размещаются вдоль дорог на территории США. ',
      ],
      process: [
        'Мы разработали IoT решение на базе облачных сервисов одного из крупнейших провайдеров мобильной связи (AT&T). Мобильный модем взаимодействует с контроллером экрана и организует клиент-серверное взаимодействие. Все протоколы коммуникаций соответствуют стандарту Департамента Транспорта США.',
      ],
      result: [
        'Данная система внедрена и используется по всей территории страны. Возможность удаленного обновления кода без выезда специалистов на место установки экрана позволила оперативно решать проблемы, найденные в процессе запуска и эксплуатации. Клиент остался очень доволен результатом! Ведь теперь можно мониторить весь парк мобильных информационных экранов, не отходя от компьютера, и обновлять информацию, отображаемую на них, в течение нескольких секунд.',
      ],
    },
    shortDescription:
      'Компания National Signal решила пойти в сторону облачных решений для диагностики и обновления информации на мобильных табло на территории США.',
    images: [
      '/images/projects/national-signal/1.jpg',
      '/images/projects/national-signal/2.jpg',
      '/images/projects/national-signal/3.jpg',
    ],
  },
  {
    name: 'Grabber',
    slug: 'grabber',
    mainImage: '/images/projects/grabber/grabber_mainbanner_1920px.jpg',
    description: {
      issue: [
        'В рамках летней практики, проходившей в 2021 году по направлению Unity, студентам было предложено реализовать проект, в котором бы была реализована манипуляция с помощью контролеров.',
        'После обсуждения с командой, за основу была взята 3D модель промышленного ангара с краном-подъемником. Далее разработчики добавили недостающие 3D модели и проработали игровой процесс. В результате получился VR-проект Grabber.',
      ],
      process: [
        'Одной из самых сложных задач, с которой ребята столкнулись во время разработки - необходимость создания правдоподобного взаимодействия между объектами, учитывая физику и соблюдая баланс массы и жесткости сцепления каждой подвижной части. Путем калибровки и поиска вариантов удалось прийти к нужному результату.',
        'Второй, но не менее важной задачей, с которой столкнулись разработчики - это оптимизация производительности, т.к. из-за большого количества объектов возрастала нагрузка на CPU. Была проведена достаточно большая работа, чтобы это исправить.',
        'На завершающем этапе разработки к проекту подключились 3D художники, которые довели модели и освещение проекта до хорошего качества с сохранением высокой производительности. Это позволило сгустить атмосферу за счет теней и бликов, сохранив картинку объемной и живой.',
        'И в завершении, чтобы сделать управление рычагами более реалистичным, мы создали модель подставок-держателей, а один из сотрудников напечатал их на 3D-принтере.',
      ],
      result: [
        'Результатом стала разработанная игра, в которой пользователь должен захватить бочки с конвейера и утилизировать в измельчителе.',
      ],
    },
    images: [
      '/images/projects/grabber/grabber_screenshot_1.jpg',
      '/images/projects/grabber/grabber_screenshot_2.jpg',
      '/images/projects/grabber/grabber_screenshot_3.jpg',
    ],
    thumbnail: '/images/projects/grabber/grabber_projectpage_990px.jpg',
    videos: [
      {
        id: Math.random().toString(36).substring(2),
        poster: '/images/projects/grabber/grabber_projectpage_990px.jpg',
        sources: [
          {
            src: '/videos/projects/grabber/Grabber_portfolio_01.mp4',
            type: 'video/mp4',
          },
          {
            src: '/videos/projects/grabber/Grabber_portfolio_01.webm',
            type: 'video/webm',
          },
        ],
      },
    ],
  },
];

const projectsSlugs = ['catch-up', 'pitstop', 'trivver'];

const projectsSlides = projects.filter(({ slug }) =>
  projectsSlugs.includes(slug),
);

export { projectsSlides, projects };



// WEBPACK FOOTER //
// ./src/data/mockProjects.js